// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__3Bix7","emptyMessage":"Notification_emptyMessage__1EcNi"};